var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 77,
    viewBox: "0 0 168 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.5 3.00012C164.366 3.00012 167.5 6.13412 167.5 10.0001C167.5 13.8661 164.366 17.0001 160.5 17.0001H120.5C124.366 17.0001 127.5 20.1341 127.5 24.0001C127.5 27.8661 124.366 31.0001 120.5 31.0001H142.5C146.366 31.0001 149.5 34.1341 149.5 38.0001C149.5 41.8661 146.366 45.0001 142.5 45.0001H132.326C127.452 45.0001 123.5 48.1341 123.5 52.0001C123.5 54.5774 125.5 56.9108 129.5 59.0001C133.366 59.0001 136.5 62.1341 136.5 66.0001C136.5 69.8661 133.366 73.0001 129.5 73.0001H46.5C42.634 73.0001 39.5 69.8661 39.5 66.0001C39.5 62.1341 42.634 59.0001 46.5 59.0001H7.5C3.634 59.0001 0.5 55.8661 0.5 52.0001C0.5 48.1341 3.634 45.0001 7.5 45.0001H47.5C51.366 45.0001 54.5 41.8661 54.5 38.0001C54.5 34.1341 51.366 31.0001 47.5 31.0001H22.5C18.634 31.0001 15.5 27.8661 15.5 24.0001C15.5 20.1341 18.634 17.0001 22.5 17.0001H62.5C58.634 17.0001 55.5 13.8661 55.5 10.0001C55.5 6.13412 58.634 3.00012 62.5 3.00012H160.5ZM160.5 31.0001C164.366 31.0001 167.5 34.1341 167.5 38.0001C167.5 41.8661 164.366 45.0001 160.5 45.0001C156.634 45.0001 153.5 41.8661 153.5 38.0001C153.5 34.1341 156.634 31.0001 160.5 31.0001Z",
    fill: "#FBBA3E",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.667 33.6876V21.8168C109.667 16.4263 109.667 13.731 108.618 11.6721C107.695 9.86107 106.222 8.38863 104.411 7.46585C102.352 6.41679 99.6571 6.41679 94.2666 6.41679H73.7333C68.3427 6.41679 65.6475 6.41679 63.5886 7.46585C61.7775 8.38863 60.3051 9.86107 59.3823 11.6721C58.3333 13.731 58.3333 16.4263 58.3333 21.8168V55.1835C58.3333 60.574 58.3333 63.2692 59.3823 65.3281C60.3051 67.1392 61.7775 68.6116 63.5886 69.5344C65.6475 70.5835 68.3427 70.5835 73.7333 70.5835H82.3958M116.083 70.5835L111.271 65.771M114.479 57.7501C114.479 63.9518 109.452 68.9793 103.25 68.9793C97.0482 68.9793 92.0208 63.9518 92.0208 57.7501C92.0208 51.5484 97.0482 46.521 103.25 46.521C109.452 46.521 114.479 51.5484 114.479 57.7501Z",
    stroke: "#FBBA3E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 61.5001L107 54.0001",
    stroke: "#FBBA3E",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107 61.5001L99.5 54.0001",
    stroke: "#FBBA3E",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.64636f3e2b2311bf5207bee2c1c421d2.svg";
export { ForwardRef as ReactComponent };